var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6032 4.51611H27.0977C25.4349 4.51611 24.0869 5.86411 24.0869 7.52695V28.6028C24.0869 30.2656 25.4349 31.6136 27.0977 31.6136H28.6032C30.266 31.6136 31.614 30.2656 31.614 28.6028V7.52695C31.614 5.86411 30.266 4.51611 28.6032 4.51611Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.818 13.5488H17.3126C15.6498 13.5488 14.3018 14.8968 14.3018 16.5597V28.603C14.3018 30.2658 15.6498 31.6138 17.3126 31.6138H18.818C20.4808 31.6138 21.8288 30.2658 21.8288 28.603V16.5597C21.8288 14.8968 20.4808 13.5488 18.818 13.5488Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03285 24.0864H7.52743C5.8646 24.0864 4.5166 25.4344 4.5166 27.0973V28.6027C4.5166 30.2655 5.8646 31.6135 7.52743 31.6135H9.03285C10.6957 31.6135 12.0437 30.2655 12.0437 28.6027V27.0973C12.0437 25.4344 10.6957 24.0864 9.03285 24.0864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorwhite);
export default __webpack_public_path__ + "static/media/vectorwhite.925aa3e5377d1efb91c2a5cc2311b55e.svg";
export { ForwardRef as ReactComponent };